import { useSyncExternalStore } from 'react';

let deferredPrompt = null;
let installed = Boolean(
  typeof window !== 'undefined' &&
  ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true),
);
let snapshot = { canPrompt: false, isInstalled: installed };
const listeners = new Set();

const updateSnapshot = (changes) => {
  snapshot = { ...snapshot, ...changes };
  listeners.forEach(listener => listener());
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPrompt = event;
    updateSnapshot({ canPrompt: true });
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    installed = true;
    updateSnapshot({ canPrompt: false, isInstalled: true });
  });
}

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const usePwaInstall = () => useSyncExternalStore(subscribe, () => snapshot, () => snapshot);

export const promptPwaInstall = async () => {
  if (!deferredPrompt) return false;

  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  updateSnapshot({ canPrompt: false });

  await promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  if (choice?.outcome === 'accepted') {
    installed = true;
    updateSnapshot({ isInstalled: true });
  }
  return true;
};